module.exports = __webpack_public_path__ + "static/Osiris-Ibague-29dd2c2328a6201a2c279258aab00302.png";